import AccountingReportLogList from "../components/accounting-reports-crud/AccountingReportLogList";

const AccountingReportHistoryPage = () => {
  return (
    <>
      <AccountingReportLogList />
    </>
  );
};

export default AccountingReportHistoryPage;
